import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  HostBinding,
  Input,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { UrlUtilsService } from '@rd/core/services/url-utils/url-utils.service';
import { WindowRefService } from '@rd/core/services/window-ref/window-ref.service';
import { WindowResizeService } from '@rd/core/services/window-resize/window-resize.service';
import {
  detectViewPort,
  responsiveBackgroundImage,
  ViewPortType,
} from '@rd/helpers/responsive-image.helper';
import { LoyaltyProgram } from '@rd/types';
import * as CSS from 'csstype';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

type ComponentRenderState = 'loading' | 'content';

@Component({
  selector: 'rd-tcv2-checkout-banner',
  templateUrl: './checkout-banner.component.html',
  styleUrls: ['./checkout-banner.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TcV2CheckoutBannerComponent implements OnInit, OnDestroy {
  @HostBinding('class.rd-tcv2-checkout-banner') componentClass = true;
  @Input() loading: boolean;
  @Input() loyaltyProgram: LoyaltyProgram;

  componentRenderState: ComponentRenderState;
  isMobileViewport: boolean;
  viewPortType: ViewPortType;

  private destroy$ = new Subject();

  constructor(
    protected cdRef: ChangeDetectorRef,
    protected urlUtilsService: UrlUtilsService,
    protected windowResizeService: WindowResizeService,
    protected windowRefService: WindowRefService,
  ) {}

  ngOnInit(): void {
    this.detectViewportSize();
    this.setupSubscriptions();
  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
  }

  getComponentRenderState(): ComponentRenderState {
    if (this.loading) {
      return 'loading';
    } else {
      return 'content';
    }
  }

  backgroundImageStyle(): CSS.Properties {
    // TODO: images belong to GC banner, should be replaced with real image later
    return responsiveBackgroundImage({
      devicePixelRatio: this.windowRefService.nativeWindow.devicePixelRatio,
      viewPortType: this.viewPortType,
      srcset: {
        mobile: this.urlUtilsService.imageUrl('/images/GC-kv-mobile.jpg'),
        mobile2x: this.urlUtilsService.imageUrl('/images/GC-kv-mobile.jpg'),
        desktop: this.urlUtilsService.imageUrl('/images/GC-kv-desktop.jpg'),
        desktop2x: this.urlUtilsService.imageUrl('/images/GC-kv-desktop.jpg'),
      },
    });
  }

  bannerTitleParams(): { loyaltyProgramName: string } {
    return {
      loyaltyProgramName: this.loyaltyProgram.shortName,
    };
  }

  private setupSubscriptions(): void {
    this.windowResizeService.windowResizeObservable
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => this.detectViewportSize());
  }

  private detectViewportSize(): void {
    detectViewPort(
      this.cdRef,
      this.viewPortType,
      this.windowRefService.nativeWindow.innerWidth,
      (viewPortType: ViewPortType) => {
        this.viewPortType = viewPortType;
      },
    );
  }
}
